<template>
  <v-card>
    <v-form @submit.prevent="uploadFile" ref="form">
      <v-container grid-list-lg>
        <v-layout wrap>
          <v-flex xs12 class="flex-container-space-between vertical-center-container">
            <div class="headline">{{title}}</div>
          </v-flex>
          <v-flex xs12 sm6>
            <v-select
              :items="models"
              v-model="model"
              label="* Masterfile"
              :prepend-icon="$store.state.global.pages.contractor.icon"
              :color="$store.state.global.pages.contractor.color"
              :rules="modelRules"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6>
            <v-select
              :items="resourceTypes"
              v-model="resourceType"
              item-text="text"
              item-value="value"
              label="* Resource Type"
              prepend-icon="build"
              :color="primaryNeutral"
              :rules="resourceTypeRules"
              :disabled="!model"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-autocomplete
              :items="subjects"
              v-model="subjectId"
              :label="`* Select ${selectedModel.text}`"
              :prepend-icon="$store.state.global.pages[selectedModel.value].icon"
              :color="primaryNeutral"
              :rules="subjectIdRules"
              item-value="id"
              :item-text="selectedModel.nameField || 'name'"
              :disabled="!model"
            ></v-autocomplete>
          </v-flex>
          <input type="file" ref="fileUpload" style="display:none" @change="onFileChange" />
          <v-flex xs12 sm6>
            <v-text-field
              :label="`* Select ${selectedResourceType} file`"
              :color="primaryNeutral"
              readonly
              :value="!!file ? file.name : ''"
              @click="openFileDialog"
              :loading="loading"
              prepend-icon="attach_file"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <date-picker-wrapper
              :label="`* Expiry Date`"
              :color="primaryNeutral"
              v-model="expiryDate"
              prepend-icon="calendar_today"
              :rules="getExpiryDateRules"
            ></date-picker-wrapper>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Notes" v-model="notes" :color="primaryNeutral" prepend-icon="note"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat color="grey darken-1" @click="close()">Close</v-btn>
        <v-btn flat color="green" :disabled="!file" :loading="loading" type="submit">
          <v-icon left>cloud_upload</v-icon>Upload
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import ComplianceService from "@/services/requests/complianceService";
import Store from "@/store/computed/storeHelpers";
import models from "./mixins/models";
import getDrivers from "@/services/mixins/getMasterFiles/getDrivers";
import getVehicles from "@/services/mixins/getMasterFiles/getVehicles";
import getContractors from "@/services/mixins/getMasterFiles/getContractors";
import AddComplianceResourceValidation from "./validation/addComplianceResourceValidation";
import DatePickerWrapper from "@/components/ui/datePickerWrapper";
export default {
  components: {
    DatePickerWrapper
  },
  mixins: [
    models,
    getDrivers,
    getVehicles,
    getContractors,
    AddComplianceResourceValidation
  ],
  props: {
    title: String,
    id: Number
  },
  data() {
    return {
      file: null,
      loading: false,
      model: null,
      resourceType: null,
      resourceTypes: [],
      // subjectId: null,
      expiryDate: "",
      notes: ""
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    openFileDialog() {
      this.$refs.fileUpload.click();
    },
    onFileChange() {
      this.file = {};
      this.file.type = this.type;
      this.file = this.$refs.fileUpload.files[0];
      this.$emit("fileSelected", this.file);
    },
    uploadFile() {
      if (!this.file) {
        this.snack({ text: "Please select a file", color: "yellow" });
        return;
      }
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("type", this.resourceType);
      formData.append("model", this.model);
      formData.append("subjectId", this.subjectId);
      formData.append("expiryDate", this.expiryDate);
      formData.append("notes", this.notes);
      this.upload(formData);
    },
    upload(formData) {
      ComplianceService.uploadComplianceResource(formData)
        .then(result => {
          this.handleSuccess(result);
        })
        .catch(err => {
          this.handleError(err);
        });
    },
    handleSuccess(result) {
      console.log(result);
      var compliance = result.data.result;
      console.log(compliance);
      this.snack({ text: result.data.message, color: "green" });
      compliance.name = !!compliance[compliance.model]
        ? compliance[compliance.model].name
        : "-";
      console.log(compliance[compliance.model].name);

      this.$store.commit("compliance/addToArrayState", {
        prop: "compliances",
        value: compliance
      });
      this.resetForm();
      this.close();
      this.loading = false;
    },
    handleError(err) {
      console.log(err);
      this.snack({ text: err.response.data.message, color: "red" });
      this.loading = false;
    },
    downloadFile() {
      console.log("download file");
    },
    resetForm() {
      this.type = null;
      this.resourceType = null;
      this.expiryDate = "";
      this.file = null;
      this.notes = "";
      this.$refs.fileUpload.value = "";
      // this.subjectId = null;
    },
    // getResourceTypes() {
    //   this.resourceTypes = [];
    //   for (var model of this.models) {
    //     if (model.value == this.model || !this.model) {
    //       Array.prototype.push.apply(this.resourceTypes, model.resourceTypes);
    //     }
    //   }
    // }
  },
  computed: {
    // model: Store.getSet({store: 'compliance', prop: 'model'}),
    subjectId: Store.getSet({ store: "compliance", prop: "subjectId" }),
    //resourceTypes: Store.getSet({ store: "compliance", prop: "resourceTypes" }),
    selectedModel() {
      if (!this.model) {
        const model = { text: "Model", resourceTypes: [], value: "contractor" };
        console.log(model);

        return model;
      } else {
        const filteredModels = this.models.filter(
          model => model.value == this.model
        );
        console.log(filteredModels);

        return filteredModels[0];
      }
    },
    selectedResourceType() {
      for (var type of this.resourceTypes) {
        if (type.value == this.resourceType) {
          return type.text;
        }
      }
      return "";
    },
    // resourceTypes() {
    //   return this.selectedModel.resourceTypes;
    // },
    subjects() {
      if (!!this.selectedModel.value)
        return this[`${this.selectedModel.value}s`];
      return [];
      // switch(this.selectedModel.value) {
      //     case('driver'):
      //         return this.drivers
      //     case('vehicle'):
      //         return this.vehicles
      //     case('contractor'):
      //         return this.contractors
      //     default:
      //         return []
      // }
    },
    getExpiryDateRules() {
      return this.resourceType == "soa" ? [true] : this.expiryDateRules;
    }
  },
  watch: {
    model() {
      this.getResourceTypes();
      this.resourceType = null;
      this.subjectId = null;
    }
  }
};
</script>

<style>
</style>
